import { AsyncAction } from "src/state/_types";
import { Users_Set_Input } from "src/state/gql/_types";

export const updateProfile: AsyncAction<Users_Set_Input, boolean> = async ({ state, actions }, payload) => {
    let id = state.auth.user_id
    if (!id) return false

    let updatedItem = await actions.users.updateItem({ id, _set: payload })
    if (updatedItem) {
        state.profile = updatedItem
        return true
    }
    return false
}
